<template>
    <proposal-form v-if="appIsHydrated && item != null" :item="item" :isClone="true" />
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import ProposalForm from './Form.vue';

    export default {
        components: {
            ProposalForm
        },

        data() {
            return {
                item: null
            }
        },

        computed: {
            ...mapGetters(['defaultTermsAndConditions', 'appIsHydrated', 'currentUserId', 'proposalById']),
            proposalId() {
                return this.$route.params.slug
            },
        },

        created() {
            this.clearProjectServices()
            this.cloneProposalById(this.proposalId).then(p => {
                    this.item = p.data.data
                    this.item.created_by = this.currentUserId
                    this.item.date_created = moment().format('YYYY-MM-DD')
                })
        },


        methods: {
            ...mapActions(['clearProjectServices', 'cloneProposalById']),
        }
    }
</script>
